import React from 'react';
import { Typography } from 'carbon-react/lib/components/typography/typography.component';

import * as styles from './virtualized-card-list-empty-state.scss';
import emptyListImage from './empty-list.svg';

interface VirtualizedCardListEmptyStateProps {
  title: string;
  description?: string;
  action?: React.ReactNode;
}

export const VirtualizedCardListEmptyState = ({ title, description, action }: VirtualizedCardListEmptyStateProps) => {
  return (
    <div className={styles.container}>
      <img src={emptyListImage} alt="Empty list" />
      <Typography fontSize="14px" fontWeight="500" mb={0}>
        {title}
      </Typography>
      {description && (
        <Typography fontSize="14px" color="rgba(0, 0, 0, 0.65)" mb={3}>
          {description}
        </Typography>
      )}
      {action}
    </div>
  );
};
